import { saveAs } from 'file-saver';

export class ImageBlob {
    private _blob: File | Blob | string | null = null;
    private _filename: string | null = null;
    private _url: string | null = null;
    private _uid: string | null = null;
    private _type: string | null = null;
    private _size: number | null = null;

    constructor(file: File | Blob | string | null) {
        if (file != null) {
            // Are we provided with a File or Blob? If so, we need to parse it out.
            if (file instanceof File || file instanceof Blob) {
                this._blob = file;
                this._url = URL.createObjectURL(this._blob);
                this._filename = file instanceof File ? file.name : '';
                this._type = file?.type || '';
                this._size = file.size ?? null;
            } else if (typeof file === 'string' && !!file) {
                // Assume this a data url of an already created asset.
                this._blob = file;
                this._url = file;
                this._filename = '';
                this._type = '';
                this._size = null;
            }

            const guidRegex = new RegExp(/[{]?([0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12})[}]?/);
            this._uid = guidRegex.test(this._url || '') ? this._url?.match(guidRegex)?.[1] || '' : '';
        }
    }

    public static FromBase64(stream: string) {
        if (!stream) return null;

        const imageContent = atob(stream);
        const buffer = new ArrayBuffer(imageContent.length);
        const view = new Uint8Array(buffer);

        for (let n = 0; n < imageContent.length; n++) {
            view[n] = imageContent.charCodeAt(n);
        }
        const type = 'image/jpg';
        const blob = new Blob([buffer], { type });
        const file = new File([blob], '', { lastModified: new Date().getTime(), type });

        return new ImageBlob(file);
    }

    dispose() {
        if (!!this._url) {
            this._url = (URL.revokeObjectURL(this._url), null);
            this._blob = null;
        }
    }

    get url() {
        return this._url;
    }

    get image() {
        return this._blob;
    }

    get uid() {
        return this._uid;
    }

    get filename() {
        return this._filename;
    }
    set filename(__filename: string | null) {
        this._filename = __filename;
    }

    get size() {
        return this._size;
    }

    get type() {
        return this._type;
    }

    // #region Save Image

    SaveImage() {
        if (!this._blob) return;

        saveAs(this._blob, this._filename || '');
    }

    // #endregion
}
